// import { pdf } from '@react-pdf/renderer';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
// import SalesInvoicePDF from '../../components/StockReports/SalesInvoicePDF'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'audit/'

const initialState = {
    masterData: [],
    salesDetail: [],
    listData: [],
    varianceReport: [],
    auditHistory: [],
    systemStock: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getAllAuditList = createAsyncThunk('audit/gaal', async (getOrder, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getAllAuditList', getOrder)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAuditData = createAsyncThunk('audit/gead', async (auditID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getAuditData', auditID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addMasterRecord = createAsyncThunk('audit/amd', async (masterData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addMasterRecord', masterData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addItem = createAsyncThunk('audit/ai', async (itemData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addItem', itemData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const closeAudit = createAsyncThunk('audit/claudit', async (auditID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'closeAudit', auditID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateAuditItem = createAsyncThunk('audit/updateItem', async (itemData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'updateAuditItem', itemData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteAuditItem = createAsyncThunk('audit/deleteItem', async (itemData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'deleteAuditItem', itemData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getVarianceReport = createAsyncThunk('audit/getVariance', async (auditID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getVarianceReport', auditID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const approveAudit = createAsyncThunk('audit/approve', async (approvalData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'approveAudit', approvalData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const rejectAudit = createAsyncThunk('audit/reject', async (rejectionData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'rejectAudit', rejectionData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAuditHistory = createAsyncThunk('audit/getHistory', async (auditID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getAuditHistory', auditID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSystemStock = createAsyncThunk('audit/getSystemStock', async (stockData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getSystemStock', stockData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const saveOpeningStockEntry = createAsyncThunk('audit/saveOpeningStockEntry', async (stockData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'saveOpeningStockEntry', stockData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const applyAuditToStock = createAsyncThunk('audit/applyToStock', async (applyData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'applyAuditToStock', applyData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const counterSalesSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.salesDetail = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllAuditList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllAuditList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.listData = action.payload
            })
            .addCase(getAllAuditList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAuditData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAuditData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(getAuditData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(addMasterRecord.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addMasterRecord.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(addMasterRecord.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(addItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(addItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(closeAudit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(closeAudit.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.listData = action.payload
            })
            .addCase(closeAudit.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(updateAuditItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateAuditItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(updateAuditItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(deleteAuditItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteAuditItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(deleteAuditItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getVarianceReport.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getVarianceReport.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.varianceReport = action.payload
            })
            .addCase(getVarianceReport.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(approveAudit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(approveAudit.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(approveAudit.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(rejectAudit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(rejectAudit.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(rejectAudit.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAuditHistory.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAuditHistory.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.auditHistory = action.payload
            })
            .addCase(getAuditHistory.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getSystemStock.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSystemStock.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.systemStock = action.payload
            })
            .addCase(getSystemStock.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(saveOpeningStockEntry.pending, (state) => {
                state.isLoading = true
            })
            .addCase(saveOpeningStockEntry.fulfilled, (state) => {
                state.isLoading = false
                state.isSuccess = true
            })
            .addCase(saveOpeningStockEntry.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(applyAuditToStock.pending, (state) => {
                state.isLoading = true
            })
            .addCase(applyAuditToStock.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                if (action.payload && action.payload.data) {
                    state.masterData = action.payload.data
                }
            })
            .addCase(applyAuditToStock.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = counterSalesSlice.actions

export default counterSalesSlice.reducer

